import { render } from "./RecordsTable.vue?vue&type=template&id=386a271c&scoped=true"
import script from "./RecordsTable.vue?vue&type=script&lang=js"
export * from "./RecordsTable.vue?vue&type=script&lang=js"

import "./RecordsTable.vue?vue&type=style&index=0&id=386a271c&scoped=true&lang=css"

import exportComponent from "D:\\Documentos\\GitHub\\FACTURAR\\ed_facturar_view\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386a271c"]])

export default __exports__